import { getClientFeedUrl } from '~/services/request/index.ts';
import { Player } from '@brightcove/web-sdk/ui';
import { useEffect } from 'react';

const DEFAULT_OVERLAY_DURATION = 30;

const usePlayNext = (
  player: Player | null,
  playNext: (event: any) => void,
  playNextFeedUrl: string | null,
  setIsRunningPlayNext: any,
  setPlayNextFeed: any,
  setDuration: any,
  setCurrentPosition: any
) => {
  const fetchPlayNextFeed = async () => {
    if (!playNextFeedUrl) return;

    const clientFeedUrl: string = getClientFeedUrl(playNextFeedUrl);

    const response = await fetch(clientFeedUrl);

    const feed = await response.json();

    setPlayNextFeed(feed);
  };

  const showPlayNextOverlay = () => {
    if (!player) return;

    const duration = player.getDuration() || 0;
    const currentPosition = player.getCurrentTime();

    setDuration(duration);
    setCurrentPosition(currentPosition || 0);

    const triggerTime = Math.abs(duration - DEFAULT_OVERLAY_DURATION) - 1;

    if (!currentPosition || !triggerTime) {
      return;
    }

    if (currentPosition <= triggerTime) {
      setIsRunningPlayNext(false);
    }

    if (currentPosition > triggerTime) {
      setIsRunningPlayNext(true);
    }
  };

  useEffect(() => {
    if (!player || !playNextFeedUrl) return;

    player.addEventListener(
      Player.Event.PlayerTimeChanged,
      showPlayNextOverlay
    );
    player.addEventListener(
      Player.Event.PlayerLoadedMetadata,
      fetchPlayNextFeed
    );
    player.addEventListener(Player.Event.PlayerEnded, playNext);
  }, [playNext, playNextFeedUrl, player]);
};

export default usePlayNext;
